module.exports = {
	"config": {
		"siteTitle": "Gatsby Starter Site",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/fs/Documents/ninjaconcept/ninja-website/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.js",
				"ext": "js",
				"name": "404",
				"extname": ".js",
				"basename": "404.js",
				"dirname": "",
				"stem": "404",
				"path": "404.js",
				"absolute": "/Users/fs/Documents/ninjaconcept/ninja-website/404.js",
				"isAbsolute": false
			},
			"requirePath": "404.js",
			"path": "/404/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "blog.js",
				"ext": "js",
				"name": "blog",
				"extname": ".js",
				"basename": "blog.js",
				"dirname": "",
				"stem": "blog",
				"path": "blog.js",
				"absolute": "/Users/fs/Documents/ninjaconcept/ninja-website/blog.js",
				"isAbsolute": false
			},
			"requirePath": "blog.js",
			"path": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "datenschutz.js",
				"ext": "js",
				"name": "datenschutz",
				"extname": ".js",
				"basename": "datenschutz.js",
				"dirname": "",
				"stem": "datenschutz",
				"path": "datenschutz.js",
				"absolute": "/Users/fs/Documents/ninjaconcept/ninja-website/datenschutz.js",
				"isAbsolute": false
			},
			"requirePath": "datenschutz.js",
			"path": "/datenschutz/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "images/icons",
				"base": "manifest.json",
				"ext": "json",
				"name": "manifest",
				"extname": ".json",
				"basename": "manifest.json",
				"dirname": "images/icons",
				"stem": "manifest",
				"path": "images/icons/manifest.json",
				"absolute": "/Users/fs/Documents/ninjaconcept/ninja-website/images/icons/manifest.json",
				"isAbsolute": false
			},
			"requirePath": "images/icons/manifest.json",
			"path": "/images/icons/manifest/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "impressum.js",
				"ext": "js",
				"name": "impressum",
				"extname": ".js",
				"basename": "impressum.js",
				"dirname": "",
				"stem": "impressum",
				"path": "impressum.js",
				"absolute": "/Users/fs/Documents/ninjaconcept/ninja-website/impressum.js",
				"isAbsolute": false
			},
			"requirePath": "impressum.js",
			"path": "/impressum/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/fs/Documents/ninjaconcept/ninja-website/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "team.js",
				"ext": "js",
				"name": "team",
				"extname": ".js",
				"basename": "team.js",
				"dirname": "",
				"stem": "team",
				"path": "team.js",
				"absolute": "/Users/fs/Documents/ninjaconcept/ninja-website/team.js",
				"isAbsolute": false
			},
			"requirePath": "team.js",
			"path": "/team/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0